if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }
      
      loadThemeAssetOnce(filename) {
      const isCSS = /\.css(\?|$)/i.test(filename);
      const isJS  = /\.js(\?|$)/i.test(filename);
      
      const ref =
        (document.currentScript?.src && document.currentScript.src.includes('/assets/'))
          ? document.currentScript
          : document.querySelector(
              'script[src*="/assets/quick-add-modal.js"],' +
              'script[src*="/assets/global.js"],' +
              'link[href*="/assets/"]'
            );

      if (!ref) {
        console.warn('[assets] Could not determine CDN base for', filename);
        return;
      }

      const u = new URL(ref.src || ref.href, location.origin);
      const base = u.href.replace(/[^/]+(\?.*)?$/, '');
      const withV = base + filename + (u.search || '');   // reuse ?v=… cache-buster
      const withoutV = base + filename;

      if (isJS) {
        if (document.querySelector(`script[src^="${withoutV}"],script[src^="${withV}"]`)) return;

        const s = document.createElement('script');
        s.defer = true;
        s.src = withV;
        s.onerror = () => {
          const s2 = document.createElement('script');
          s2.defer = true;
          s2.src = withoutV; // fallback without query
          document.head.appendChild(s2);
        };
        document.head.appendChild(s);
        return;
      }

      if (isCSS) {
        if (document.querySelector(`link[rel="stylesheet"][href^="${withoutV}"],link[rel="stylesheet"][href^="${withV}"]`)) return;

        const l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = withV;
        l.onerror = () => {
          const l2 = document.createElement('link');
          l2.rel = 'stylesheet';
          l2.href = withoutV; // fallback without query
          document.head.appendChild(l2);
        };
        document.head.appendChild(l);
        return;
      }

      console.warn('[assets] Unknown asset type for', filename);
    }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // Add to cart button price change for quantity change
            initQuantityListener();
            const version = Math.random().toString(36).substring(2, 10);
            this.loadThemeAssetOnce('quick-aslowas.js?v=' + version);
            this.loadThemeAssetOnce('quick-aslowas.css?v=' + version);
            window.BreadALA_run?.(this);  
            console.log('hello');
            super.show(opener);
            var swiper = new Swiper(".block__quick-view-main-image", {
              slidesPerView: 1.2,
              spaceBetween: 10,
              mousewheel: {
                forceToAxis: true,
              },
              observer: true,
              observeParents: true,
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              breakpoints: {
                640: {
                  slidesPerView: 1.2,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 1.3,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 1.5,
                  spaceBetween: 10,
                },
              },
            });
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
